import { RichTextFormatter, translateFormatter } from '@/core/localization/translate';
export const billieBannerDescription = translateFormatter<{
  bold: RichTextFormatter;
}>([{
  "type": 0,
  "value": "Paiement jusqu\u2019\xE0 "
}, {
  "type": 8,
  "value": "bold",
  "children": [{
    "type": 0,
    "value": "30 jours,"
  }]
}, {
  "type": 0,
  "value": " sans frais"
}], undefined, undefined, "en");